import { render } from "./BurnupChart.vue?vue&type=template&id=0cfe61ba&scoped=true"
import script from "./BurnupChart.vue?vue&type=script&lang=js"
export * from "./BurnupChart.vue?vue&type=script&lang=js"

import "./BurnupChart.vue?vue&type=style&index=0&id=0cfe61ba&lang=scss&scoped=true"

import exportComponent from "/builds/springup/workstats-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cfe61ba"]])

export default __exports__